<template>
  <div class="SearchInput__Container">
    <div class="SearchInput__Input">
        <multiselect
            v-model="$store.state.search.selectedResults"
            :options="searchResults"
            :multiple="true"
            :limit="limitNumber"
            :limit-text="limitText"
            group-values="locations"
            group-label="area"
            :group-select="false"
            placeholder="Enter City, Area, Train Line or Station"
            track-by="id" label="name"
            :searchable="true"
            :loading="isLoading"
            :internal-search="true"
            :clear-on-select="true"
            :close-on-select="false"
            :hide-selected="false"
            open-direction="bottom"
            :show-no-results="true"
            @search-change="asyncFind"
            @select="onSelect"
            @close="onClose"
            class="jhf-multiselect" >

            <span slot="noResult">{{'No results found.' | language}}</span>

            <template slot="beforeList">
                <div class="search-buttons" v-if="$store.state.search.selectedResults.length > 0">
                    <el-button size="mini" @click="action('Area')" :style="{'background-color':selectedTab === 'Area' ? '#ce0018' : '','color':selectedTab === 'Area' ? '#ffffff !important' : '#ce0018'}"
                    v-if="!typeLoading && utilsService.isContainCity($store.state.search.selectedResults)">{{'Area' | language}}</el-button>
                    <el-button size="mini" @click="action('Train')" :style="{'background-color':selectedTab === 'Train' ? '#ce0018' : '','color':selectedTab === 'Train' ? '#ffffff !important' : '#ce0018'}"
                    v-if="!typeLoading && (utilsService.isContainCity($store.state.search.selectedResults) || utilsService.isContainStation($store.state.search.selectedResults))">{{'Train Lines' | language}}</el-button>
                    <el-button size="mini" @click="action('Station')" :style="{'background-color':selectedTab === 'Station' ? '#ce0018' : '','color':selectedTab === 'Station' ? '#ffffff !important' : '#ce0018'}"
                    v-if="!typeLoading && (utilsService.isContainCity($store.state.search.selectedResults) || utilsService.isContainTrainLine($store.state.search.selectedResults))">{{'Train Stations' | language}}</el-button>
                    <div v-show="typeLoading === true" style="display:flex;align-items:center;justify-content:center;width:100%">
                      <i class="fas fa-spinner fa-spin"></i>
                    </div>
                </div>
            </template>
<!-- el-button el-button--default el-button--mini -->



            <!-- selected item type -->
            <template slot="tag" slot-scope="{ option, remove }">
                <span class="multiselect__tag"  @click="remove(option);selectedTab=''">
                    <i class="fas fa-subway" v-if="option.type === 'Station'"></i>
                    <i class="trainline-icon white" v-if="option.type === 'TrainLine'"></i>
                    <i class="fas fa-city" v-if="option.type === 'City'"></i>
                    <i class="fas fa-building" v-if="option.type ==='Area'"></i>
                    <span>{{ option.name }}</span>
                    <i class="fas fa-times"></i>
                </span>
            </template>

            <!-- drop-down list template -->
            <template slot="option" slot-scope="props">
                <div class="option__desc" v-if="props.option.$groupLabel" ><span class="option__title">{{ props.option.$groupLabel }}</span></div>
                <div class="option__desc" v-if="props.option.name">
                    <i class="fas fa-subway" v-if="props.option.type === 'Station'"></i>
                    <i class="trainline-icon" v-if="props.option.type === 'TrainLine'"></i>
                    <i class="fas fa-city" v-if="props.option.type === 'City'"></i>
                    <i class="fas fa-building" v-if="props.option.type ==='Area'"></i>
                    <span class="option__title">{{ props.option.name }}</span>
                </div>
            </template>
        </multiselect>

        <el-tooltip :content="this.filterBtnTitle" placement="bottom">
            <span id="home-filters-btn" @click="showFilters"><i class="fas fa-sliders-h"></i></span>
        </el-tooltip>
    </div>
    <div class="SearchInput__Button">
        <el-button class="el-button--primary--input dropshadow" icon="el-icon-search" :inline="true" type="primary" @click="search()" ></el-button>
    </div>

  </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import utilsService from '../../services/utilsService.js'
    import { mapState } from 'vuex'
    import _ from 'lodash';
    import JQuery from 'jquery'
    let $ = JQuery

  export default {
    name: 'multi-select',
    components: { Multiselect },
    computed: {
          ...mapState({
              language: (state) => {
                  return state.general.language
              }
          })
    },
    data () {
      return {
        searchResults: [],
        typeLoading:false,
        list:[],
        isLoading: false,
        value: null,
        width: 0,
        limitNumber: 4,
        filterBtnTitle: 'Show Filters',
        utilsService: utilsService,
        selectedTab:''
      }
    },

    created() {
      this.$store.dispatch('search/defaultSearch')
      .then(response => {
        this.searchResults = response.data;
      })

      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      this.limitNumberUpdate();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods:{
       asyncFind: _.debounce(function (searchQuery) {
         if (searchQuery){
            const params = {
                ...utilsService.formatSearchQuery(this.$store.state.search.selectedResults),
                keyWord:searchQuery,
                selectedTab:this.selectedTab
            }
            this.$store.dispatch('search/search',params)
            .then(response => {
                this.searchResults = response.data;
            })
         }

      }, 500),
      search(){
          this.$store.commit('search/set_query',this.$store.state.search.selectedResults)
          const params = this.$store.state.search.query
          params.security = this.$store.state.search.security ? 1 : 0
          params.parking = this.$store.state.search.parking ? 1 : 0
          params.concierge = this.$store.state.search.concierge ? 1 : 0
          params.pet = this.$store.state.search.pet ? 1 : 0
          params.balcony = this.$store.state.search.balcony ? 1 : 0
          params.yard = this.$store.state.search.yard ? 1 : 0
          params.heating = this.$store.state.search.heating ? 1 : 0
          params.dishwasher = this.$store.state.search.dishwasher ? 1 : 0
          params.dryer = this.$store.state.search.dryer ? 1 : 0
          params.refrigerator = this.$store.state.search.refrigerator ? 1 : 0
          this.$router.push({path: '/properties',query:_.omit(params,['lat','lng']) })
      },
      onClose(){
        this.selectedTab = ''
        this.isLoading = false
      },
      onSelect(e){
        if (e.type === 'City'){
            this.$store.dispatch('search/searchByType', {'city':e.id,'type':'Area'})
             .then(resp => {
                 this.selectedTab ='Area'
                 this.searchResults = resp.data
            })
        } else if(e.type === 'TrainLine'){
            this.$store.dispatch('search/searchByType',{'trainLine':e.id,'type':'Station'})
            .then(resp => {
                this.selectedTab = 'Station'
                this.searchResults = resp.data
            })
        }
      },
      limitText(count) {
        return `+ ${count}`
      },
      limitNumberUpdate() {
        if (this.width < 700 && this.width > 500) {
          this.limitNumber = 3;
        } else if (this.width <= 500) {
          this.limitNumber = 2;
        } else {
          this.limitNumber = 4;
        }
      },
      handleResize() {
        this.width = window.innerWidth;
        this.limitNumberUpdate();
      },
      action(name) {
        this.typeLoading = true
        this.selectedTab = name
        this.$store.dispatch('search/searchByType', {...utilsService.formatSearchQuery(this.$store.state.search.selectedResults),'type':name})
            .then(resp => {
                this.searchResults = resp.data
            })
            .finally(()=>{
                this.typeLoading = false
            })
        },
        showFilters() {
            $('#advanced-search').toggleClass('show-filters');

            if (this.filterBtnTitle == 'Show Filters') {
                this.filterBtnTitle = 'Hide Filters'
            } else {
                this.filterBtnTitle = 'Show Filters'
            }
        }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
    .SearchInput {
        &__Input {
            padding: 0 !important;
            flex: 1 1;
            border-radius: 3px 0 0 3px;
            position: relative;
        }

        &__Button {
            padding: 0 !important;
            flex: 0 0 56px;
        }

        &__Container {
            display: flex;
            width: 100%;
        }
    }

    .SearchInput__Container {
        .multiselect {
            margin: 0 !important;
            border-radius: 0 !important;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            &__content {
                border: none;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

                .multiselect__element {
                    margin: 0;
                }
            }

            &__content-wrapper {
                border: none;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }

            &__option {}

            &__option--highlight {
                background-color: #424242;
            }
        }

        .multiselect__content {
            position: relative;
        }

        .search-buttons {
            position: sticky;
            top: 0;
            left: 0;
            z-index: 1;
            display: flex;
            padding: 1px;

            .el-button {
                border: 1px solid rgba($alternate-color, .3) !important;
                margin: 2px;
                border-radius: 3px !important;
                height: initial;
                flex: 1 1;
            }
        }

        .dropshadow {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }

        .el-tabs__item.is-active {
            background-color: rgba(255, 255, 255, 0.8) !important;
            border: none !important;
        }

        .el-tabs__item {
            background-color: rgba(255, 255, 255, 0.6) !important;
            border: none !important;
        }

        .el-tabs__nav {
            float: right !important;
        }

        .el-tabs__header {
            background: transparent !important;
            border-bottom: 0 !important;
        }

        .el-tabs__content {
            background: transparent !important;
            padding: 0 !important;
        }

        .el-tabs--border-card {
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
        }

        .el-button {
            height: 50px;
            border-radius: 0 3px 3px 0!important;

            .el-icon-search {
                font-weight: 600;
            }
        }

        .multiselect__tags, .multiselect__input {
            border-radius: 3px 0 0 3px;
            border: none;
            margin: 0;
            padding: 0;
            line-height: 50px;
        }

        .multiselect__tags {
            padding: 0 5px;
            cursor: pointer;
            transition: ease-in-out .2s;

            &:hover {
                box-shadow: inset 0 0 0 1px $primary-color;
            }
        }

        .multiselect__input {
            padding: 0 1rem;
            background-color: transparent;
        }

        .multiselect__tag, .multiselect__strong {
            margin: 0 5px 0 0;
            padding: 0 2em 0 .5em;
            line-height: 40px;
            vertical-align: middle;
            border-radius: 3px;
        }

        .multiselect__strong {
            padding: 0 1em;
        }

        .multiselect__tag-icon {
            line-height: 40px;

            &:after {
                font-size: 16px;
            }

            &:focus, &:hover {
                border-radius: 0 3px 3px 0;
            }
        }

        .fas {
            padding-right: .5em;
        }

        .fa-times {
            padding: 0;
            position: absolute;
            right: .5em;
            top: 50%;
            transform: translateY(-50%);
        }

        .multiselect__select:before {
            display: none;
        }

        .multiselect__placeholder {
            padding: 0 0 0 1rem;
            margin: 0;
            font-size: 16px;
        }

        #home-filters-btn {
            display: inline-block;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            background: transparent;
            border: none;
            padding: 1em;
            color: $alternate-color;
            line-height: .8em;
            cursor: pointer;

            .fas {
                padding: 0;
            }

            &:hover {
                color: $primary-color;
            }
        }

        @media (max-width: 767px) {
            .el-button {
                height: 40px;
                padding: 12px;
            }

            .multiselect__content .multiselect__element {
                font-size: 90%;
            }

            .multiselect__tags, .multiselect__input {
                line-height: 40px!important;
            }

            .multiselect__tag, .multiselect__strong {
                line-height: 30px;
                font-size: 90%;
                padding: 0 2em 0 .5em;
            }

            .multiselect__strong {
                padding: 0 .5em;
                margin: 0;
            }

            .multiselect__tag-icon {
                line-height: 30px;
            }

            .SearchInput__Button {
                height: 40px;
                flex: 0 0 40px;
            }

            #home-filters-btn {
                padding: .75em;
            }
        }
    }

    .Home {
        .multiselect__tags {
            padding: 0 3em 0 5px;
        }

        #advanced-search {
            &.show-filters {
                display: flex;
            }
        }
    }
</style>
